import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation, Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";
import "./App.css";
import { AuthProvider } from "./lib/auth";
import { api } from "./lib/api";

import Header from "./components/Header";
import Footer from "./components/Footer";

import Landing from "./pages/Landing";
import Services from "./pages/Services";
import About from "./pages/About";
import Realisations from "./pages/Realisations";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Devis from "./pages/Devis";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AuthCallback from "./pages/AuthCallback";

function PublicLayout() {
  const [settings, setSettings] = useState(null);
  const location = useLocation();
  useEffect(() => {
    api.get("/settings").then(({ data }) => setSettings(data)).catch(() => {});
  }, []);
  useEffect(() => { window.scrollTo(0, 0); }, [location.pathname]);

  // Google Analytics 4 injection
  useEffect(() => {
    const gaId = settings?.ga_measurement_id;
    if (!gaId || !/^G-[A-Z0-9]+$/i.test(gaId)) return;
    if (document.getElementById("ga4-loader")) return;
    const s1 = document.createElement("script");
    s1.id = "ga4-loader";
    s1.async = true;
    s1.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
    document.head.appendChild(s1);
    const s2 = document.createElement("script");
    s2.id = "ga4-init";
    s2.text = `window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag('js', new Date());gtag('config', '${gaId}');`;
    document.head.appendChild(s2);
  }, [settings?.ga_measurement_id]);

  // Send pageview to GA4 on route change (after script loaded)
  useEffect(() => {
    const gaId = settings?.ga_measurement_id;
    if (!gaId || typeof window.gtag !== "function") return;
    window.gtag("event", "page_view", { page_path: location.pathname });
  }, [location.pathname, settings?.ga_measurement_id]);

  return (
    <>
      <Header />
      <Outlet context={{ settings }} />
      <Footer settings={settings} />
    </>
  );
}

function AppInner() {
  const location = useLocation();
  // Process OAuth redirect callback at top level (synchronous detection during render)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route element={<PublicLayout />}>
        <Route path="/" element={<Landing />} />
        <Route path="/services" element={<Services />} />
        <Route path="/a-propos" element={<About />} />
        <Route path="/realisations" element={<Realisations />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/devis" element={<Devis />} />
      </Route>
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminDashboard />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <AuthProvider>
          <BrowserRouter>
            <AppInner />
          </BrowserRouter>
          <Toaster
            position="bottom-right"
            theme="dark"
            toastOptions={{
              style: {
                background: "#0a0a0c",
                border: "1px solid rgba(255,255,255,0.1)",
                color: "#fff",
              },
            }}
          />
        </AuthProvider>
      </HelmetProvider>
    </div>
  );
}
